import { render, staticRenderFns } from "./TopSlider.vue?vue&type=template&id=0f47ac74&scoped=true&"
import script from "./TopSlider.vue?vue&type=script&lang=js&"
export * from "./TopSlider.vue?vue&type=script&lang=js&"
import style0 from "./TopSlider.vue?vue&type=style&index=0&id=0f47ac74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47ac74",
  null
  
)

export default component.exports